var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('svgicon',{attrs:{"src":_vm.icon,"height":24}}):[_vm._v(_vm._s(_vm.text))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }